/**
 * Simple show more products on button click
 */
export default {
  init() {
    this.$productList = document.querySelector('.js-show-more-product-list');
    if (!this.$productList) return;
    this.$products = Array.prototype.slice.call(this.$productList.querySelectorAll('.post-card'));
    this.$moreButton = document.querySelector('.js-more-button');
    this.productsPerPage = this.$productList.dataset.productsPerPage ? parseInt(this.$productList.dataset.productsPerPage) : 12;
    this.currentProductsPerPage = this.productsPerPage;

    if (this.currentProductsPerPage >= this.$products.length) return;
    this.$products.forEach((product, index) => {
      if ( index + 1 > this.currentProductsPerPage ) {
        product.parentNode.classList.add('u-hide')
      }
    });
    this.$moreButton.classList.remove('u-hide');
    this.$moreButton.addEventListener('click', this.handleMoreClick.bind(this));
  },

  handleMoreClick() {
    this.currentProductsPerPage += this.productsPerPage;
    this.$products.slice(0, this.currentProductsPerPage).forEach(product => {
      product.parentNode.classList.remove('u-hide');
    });
    if (this.currentProductsPerPage >= this.$products.length) {
      this.$moreButton.classList.add('u-hide');
    } else {
      this.$moreButton.classList.remove('u-hide');
    }
  },
}
